export enum ReturnTypeEnums {
  ALL_CLOSEST_MATCHES = 'all-closest-matches',
  ALL_MATCHES = 'all-matches',
  ALL_SORTED_MATCHES = 'all-sorted-matches',
  FIRST_CLOSEST_MATCH = 'first-closest-match',
  FIRST_MATCH = 'first-match',
}
